import HttpService from "./HttpService";
import { api } from "../common/enviroment";

export default class ReportService {
  httpService = new HttpService();

  create = (data) => {
    return this.httpService.post(`/services/app${api.REPORT_SERVICE}/Create`, data);
  }

  get = (reportId) => {
    return this.httpService.get(`/services/app${api.REPORT_SERVICE}/Get?id=${reportId}`);
  }

}